<template>
  <div>
    <div class="icon-group">
      <el-tooltip content="心电图" :offset="0" effect="light">
        <img
          src="@/assets/icons/recording/heart.png"
          alt=""
          @click="showHeart = true"
        >
      </el-tooltip>
      <el-tooltip content="音频" :offset="0" effect="light">
        <img
          src="@/assets/icons/recording/recording.png"
          alt=""
          @click="showAudio = true"
        >
      </el-tooltip>
      <el-tooltip content="视频" :offset="0" effect="light">
        <img
          src="@/assets/icons/recording/video.png"
          alt=""
          @click="showCarVideo=true"
        >
      </el-tooltip>
      <el-tooltip content="图片" :offset="0" effect="light">
        <img
          src="@/assets/icons/recording/photo.png"
          alt=""
          @click="showPhotos = true"
        >
      </el-tooltip>
      <el-tooltip content="B超" :offset="0" effect="light">
        <img
          src="@/assets/icons/recording/BChao.png"
          alt=""
          @click="showBChao = true"
        >
      </el-tooltip>
      <el-tooltip
        content="轨迹"
        :offset="0"
        effect="light"
      >
        <img
          src="@/assets/icons/recording/trace.png"
          alt=""
          @click="showTrace=true"
        >
      </el-tooltip>
    </div>
    <div class="video-group">
      <audio-show
        v-if="showAudio"
        class="record-audio"
        :show-audio="showAudio"
        @closeDialog="showAudio = false"
      />
      <heart-show
        v-if="showHeart"
        :video-button="showHeart"
        @closeDialog="showHeart = false"
      />
      <camara-show
        v-if="showCarVideo"
        :video-button="showCarVideo"
        @closeDialog="showCarVideo = false"
      />
      <image-show
        v-if="showPhotos"
        :show-photos="showPhotos"
        @closeDialog="showPhotos = false"
      />
      <b-chao-show
        v-if="showBChao"
        :show-b-chao="showBChao"
        @closeDialog="showBChao = false"
      />
      <trace-show
        v-if="showTrace"
        :show-dialog="showTrace"
        @closeDialog="showTrace = false"
      />
    </div>
  </div>
</template>

<script>
import "@assets/css/recording.scss";
import AudioShow from "@components/patients/CarRecording/AudioShow.vue";
import HeartShow from "@components/stream/HeartShow";
import CamaraShow from "@components/patients/CarRecording/CamaraShow";
import BChaoShow from "@components/stream/BChaoShow";
import ImageShow from "@components/stream/ImageShow";
import TraceShow from "@components/patients/CarRecording/TraceShow";

export default {
  name: "CarRecording",
  components: {
    AudioShow,
    HeartShow,
    CamaraShow,
    BChaoShow,
    ImageShow,
    TraceShow
  },

  data() {
    return {
      showCarVideo: false,
      showHeart: false,
      showPhotos: false, // 照片展示
      showBChao: false, // B超展示
      showAudio: false,
      showTrace: false
    };
  },
};
</script>
<style lang="scss" scoped>
.icon-group ::v-deep {
  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    margin-left: 6px;
  }
}

::v-deep .select-video {
  position: relative;
  z-index: 9999;

  &:hover {
    opacity: .8;
    transition: opacity 1s;
  }

  .el-select {
    position: absolute;
    top: 0;
    z-index: 1000;
  }

  span {
    font-size: 16px;
    font-weight: bold;
    color: #999999;
  }
}

.video-group ::v-deep {
  .el-dialog__body {
    padding: 0;
    min-height: 360px;
  }
}

.record-audio ::v-deep {
  .el-button {
    font-size: 16px;
    color: #0C618B;
  }

  .el-dialog__body {
    padding: 24px;
  }
}
</style>
